import React from "react";
import ClinicTemplateInfo from "./clinic-template-info";
import ClinicInfo from "./clinic-info";
import { useLocation } from "react-router";
import ClinicBillingInfo from "./clinic-billing-info";
import ClinicComment from "./clinic-comment/clinic-comment";
import ClinicDeatils from "../clinic-details";
import ClinicContactInfo from "./clinic-contact-info/clinic-contact-info";
import StripeCustomerInfo from "./stripe-customer-Info/stripe-customer-Info";
import ClinicTextSetup from "./clinic-contact-info/clinic-text-reminder";

const ClinicInfoIndex = () => {
  const { state } = useLocation();

  return (
    <div className="row">
      <div className="col-md-6 mb-4">
        <ClinicInfo state={state} />
      </div>
      <div className="col-md-6 mb-4">
        <StripeCustomerInfo clinicInfo={state}/>
      </div>
      {/* <div className="col-md-7">
        <div className="row">
          <div className="col-md-12">
            <ClinicContactInfo />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-12">
            <ClinicComment />
          </div>
        </div>
      </div> */}

      <div className="col-md-6 mb-4">
        <ClinicTextSetup />
      </div>
      <div className="col-md-6 mb-4">
      <ClinicContactInfo />
      </div>
      <div className="col-md-6 mb-4">
      <ClinicComment />
      </div>

      <div className="col-md-6 mb-4">
        <ClinicTemplateInfo clinicInfo={state} />
      </div>
      <div className="col-md-6">
        <ClinicBillingInfo clinicInfo={state} />
      </div>
     
          <div className="col-md-12">
            <ClinicDeatils />
          </div>
    </div>

    
  );
};

export default ClinicInfoIndex;
